import React, { useEffect, useState } from 'react';
import { FloatingSection } from '@abyss/web/ui/FloatingSection';
import { Layout } from '@abyss/web/ui/Layout';
import { Button } from '@abyss/web/ui/Button';

type SavePromptProps = {
  form: any;
  formData?: any;
  save?(): void;
  discard?(): void;
};

const SavePrompt: React.FC<SavePromptProps> = ({
  form,
  formData,
  save,
  discard = undefined,
}: SavePromptProps) => {
  const [promptVisible, setPromptVisible] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const HandleDiscardClick = async () => {
    if (discard) {
      await discard();
    } else {
      await form.reset(undefined,{
        keepDirty: false,
      });
    }
    await setPromptVisible(false);
    await setButtonDisabled(false);
  };

  const HandleSaveClick = async () => {
    const { errors, isValid } = form.formState;
    if (save) {
      if (JSON.stringify(errors) === JSON.stringify({}) && isValid == true) {
        await save();
        await setButtonDisabled(true);
        await setPromptVisible(false);
      }
    }
  };

  useEffect(() => {
    const load = async () => {
      const { isDirty, dirtyFields } = form.formState;
      if (
        isDirty === true &&
        JSON.stringify(dirtyFields) !== JSON.stringify({})
      ) {
        await setPromptVisible(true);
        await setButtonDisabled(false);
      }
      else {
        await setPromptVisible(false);
        await setButtonDisabled(true);
      }
    };
    load();
  }, [form.formState]);

  return (
    <React.Fragment>
      <FloatingSection
        alwaysFloat
        space={50}
        css={{
          'abyss-floating-section-root': {
            minHeight: '72px',
            display: promptVisible === false ? 'none!important' : 'block',
            alignItems: 'center',
            padding: '$md',
            position: 'fixed',
            width: '100%',
            left: 0,
            bottom: 0,
            borderTop: 'solid 2px $gray3',
            zIndex: '1000'
          },
        }}
      >
        <Layout.Stack space={30} grow>
          <Layout.Group space={20} alignLayout="center">
            <Button
              variant="outline"
              type="button"
              onClick={HandleDiscardClick}
            >
              Discard
            </Button>
            <Button
              type="submit"
              onClick={HandleSaveClick}
              isDisabled={buttonDisabled}
            >
              Save
            </Button>
          </Layout.Group>
        </Layout.Stack>
      </FloatingSection>
    </React.Fragment>
  );
};

export { SavePrompt };
